var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-dependency-injection";
import { BaseWidget } from "./base-widget";
import { Router } from "aurelia-router";
import * as Enumerable from "linq";
import { SignalClientService } from "../services/basics/signal-client.service";
var EntityFinderWidget = /** @class */ (function (_super) {
    __extends(EntityFinderWidget, _super);
    function EntityFinderWidget(router, signalClientService) {
        var _this = _super.call(this, signalClientService) || this;
        _this.router = router;
        _this.supportedEntityTypes = [];
        return _this;
    }
    EntityFinderWidget.prototype.onActivate = function (model) {
        this.supportedEntityTypes = model;
    };
    EntityFinderWidget.prototype.searchItemSelected = function (e) {
        if (e.detail && e.detail.selectedEntityType && e.detail.selectedEntity) {
            var route = Enumerable.from(this.router.routes).firstOrDefault(function (x) { return x.entityTypeRoute == e.detail.selectedEntityType &&
                !x.claimsRequired; });
            this.router.navigateToRoute(route.name, { id: e.detail.selectedEntity.id });
        }
    };
    EntityFinderWidget = __decorate([
        autoinject,
        __metadata("design:paramtypes", [Router, SignalClientService])
    ], EntityFinderWidget);
    return EntityFinderWidget;
}(BaseWidget));
export { EntityFinderWidget };
